<template>
  <v-container class="text-left" style="padding: 0px !important" fluid>
    <v-row>
      <v-col md="12">
        <v-data-table
          :headers="headers"
          :options.sync="options"
          :server-items-length="serverItemsLength"
          :loading="loading"
          :items="users"
        >
          <template v-slot:item.confirmed="{ item }">
            <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
            <v-icon v-else color="error">fa-times</v-icon>
          </template>
          <template v-slot:item.improve="{ item }">
            <v-switch
              :disabled="item.company.data.state == 4"
              @change="
                item.is_improve_content
                  ? addImproveContent(item.id)
                  : removeContent(item.company_id, item.id, 0)
              "
              v-model="item.is_improve_content"
              :value="item.is_improve_content"
            ></v-switch>
          </template>
          <template v-slot:item.edify="{ item }">
            <v-switch
              :disabled="item.company.data.state == 4"
              @change="
                item.is_edify_content
                  ? addEdifyContent(item.id)
                  : removeContent(item.company_id, item.id, 1)
              "
              v-model="item.is_edify_content"
              :value="item.is_edify_content"
            ></v-switch>
          </template>
          <template v-slot:item.id="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="item.state == 4"
                  :id="item.id"
                  v-on="on"
                  outlined
                  small
                  color="secondary"
                  @click.prevent="showEditPanel(item.id)"
                >
                  <v-icon small>fa-pencil-alt</v-icon>
                </v-btn>
              </template>
              <span>Edit User</span>
            </v-tooltip>
            <!-- State Suspend button -->
            <v-tooltip bottom v-if="item.company.data.state != 4">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="error"
                  class="ml-1"
                  outlined
                  small
                  @click.prevent="updateState(item.company.data.id, 'suspend')"
                >
                  <v-icon small>fa fa-ban</v-icon>
                </v-btn>
              </template>
              <span>Suspend Company</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="error"
                  class="ml-1"
                  outlined
                  small
                  @click.prevent="updateState(item.company.data.id, 'active')"
                >
                  <v-icon small>fa fa-undo</v-icon>
                </v-btn>
              </template>
              <span>Active Company</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import superAdminAPI from '@/api/superadmin.js';
import partnerAPI from '@/api/partner.js';
import userAPI from '@/api/user.js';
import LayoutBasic from '@/layouts/Dashboard';
import EditUser from '@/components/superadmin/users/Edit';
import CreateUser from '@/components/admin/users/Create';
import ViewDetails from '@/components/admin/users/View';
import ShowPopup from '@/components/superadmin/companies/ImproveContentPopup';
import EdifyPopup from '@/components/superadmin/companies/EdifyContentPopup';
import improveAPI from '@/api/superadmin.js';
import companyAPI from '@/api/company.js';

export default {
  name: 'SuperAdminCompanyUsers',
  components: {
    LayoutBasic,
    ShowPopup,
    EdifyPopup,
  },
  data() {
    return {
      headers: [
        { text: 'Company', value: 'company.data.company_name' },
        {
          text: 'Banding',
          value: 'company.data.banding_description.name',
          sortable: false,
        },
        {
          text: 'Compliance',
          value: 'improve',
          sortable: false,
        },
        {
          text: 'Safeguarding',
          value: 'edify',
          sortable: false,
        },
        {
          text: 'Total Users',
          value: 'company.data.total_members',
          sortable: false,
        },
        {
          text: 'Total Courses',
          value: 'company.data.total_courses',
          sortable: false,
        },
        {
          text: 'State',
          value: 'company.data.state_description',
          sortable: false,
        },
        { text: 'First Name', value: 'first_name' },
        //{ text: "Surname", value: "last_name" },
        { text: 'Email', value: 'email' },
        { text: 'Last Login', value: 'last_login', sortable: false },
        //{ text: "Courses", value: "total_courses", sortable: false },
        //{ text: "Groups", value: "total_groups", sortable: false },
        //{ text: "Playlists", value: "total_channels", sortable: false },
        { text: '', value: 'id', align: 'end' },
      ],
      partnerId: this.$route.params.id,
      users: [],
      companies: [],
      partner: [],
      search: '',
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      confirmDelete: 'Are you sure you wish to delete this user?',
      confirmRemoveContent: 'Are you sure you want to remove all courses?',
      successMessage: 'content successfully activated.',
      removeContentMessage: 'content now deactivated.',
      confirmUpdateCompanyState: 'Are you sure you wish to update state to ',
      successUpdateStateMessage: 'State has been updated Successfully',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
  },
  mounted() {
    this.setEventBus();
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true,
    },
  },
  methods: {
    getUsers() {
      this.loading = true;
      //userAPI.getClients(this.params, this.searchParams, this.companyId).then(resp => {
      //partnerAPI.getPartnerDetailByUserId(this.partnerId, this.params+ '&include=partnerusers').then(resp => {
      partnerAPI
        .getPartnersUser(
          this.params + '&include=company',
          this.searchParams,
          this.partnerId
        )
        .then((resp) => {
          this.users = resp.data.data;
          //this.companies = resp.data.data.company.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        });
    },
    resetSearch() {
      this.searchParams = '';
      this.getUsers();
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        this.params = payload;
        this.getUsers();
      });
    },
    applySearch() {
      this.searchParams =
        this.params +
        '&search=first_name:' +
        this.search +
        ';last_name:' +
        this.search;
      this.getUsers();
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    addImproveContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyImproveContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Compliance ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.getUsers();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    addEdifyContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Safeguarding ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.getUsers();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    removeContent(id, userId, contentType) {
      this.$snotify.confirm(this.confirmRemoveContent, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button', action: (toast) => this.removeToast(toast) },
          {
            text: 'Continue',className: 'toast-continue-button',
            action: (toast) =>
              this.processRemoveContent(toast, id, userId, contentType),
          }          
        ],
      });
    },
    removeToast(toast) {
      this.$snotify.remove(toast.id);
      this.getOwners();
    },
    processRemoveContent(toast, id, userId, contentType) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      superAdminAPI
        .removeEdifyImproveContent(id, userId, contentType)
        .then((resp) => {
          this.getOwners();
          this.loading = false;
          var successMessage = contentType
            ? 'Safeguarding ' + this.removeContentMessage
            : 'Compliance ' + this.removeContentMessage;
          this.$snotify.success(successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    updateState(id, state = '') {
      var confirmUpdateCompanyState =
        this.confirmUpdateCompanyState + state + '?';
      this.$snotify.confirm(confirmUpdateCompanyState, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel',className: 'toast-cancel-button' },
          {
            text: 'Continue',className: 'toast-continue-button',
            action: (toast) => this.processUpdateCompanyState(toast, id, state),
          }          
        ],
      });
    },
    processUpdateCompanyState(toast, id, state) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      companyAPI.updateCompanyState(id, '', state).then(() => {
        this.$snotify.success(this.successUpdateStateMessage);
        this.getUsers();
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
  },
};
</script>
